export const config = {
  rowSelection: false,
  columns: [
    {
      title: "门店",
      dataIndex: "companyName",
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: "变量类型",
      width: 200,
      dataIndex: "varTypeName",
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: "变量值",
      dataIndex: "varValue",
      width: 150
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: "最后更新人",
      dataIndex: "modifiedByName",
      width: 150
    },
    {
      title: "最后更新时间",
      dataIndex: "lastUpdatedTime",
      width: 180,
      ellipsis: {
        showTitle: true,
      },
      itemType: 'dateTime'
    },
    {
      title: "操作",
      dataIndex: "bindType",
      width: 180,
      render: "operation",
      fixed: "right"
    }
  ],
  search: [
    {
      name: "companyId",
      label: "门店",
      itemType: "select",
      data: "companyList",
      labelKey: "name",
      key: "id"
    }
  ],
  footer: [
    {
      label: "新建",
      type: "primary",
      events: ["onClick:onAdd"]
    }
  ]
}
